
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.304 3.743a1.563 1.563 0 00-1.43-.93H3.125A1.562 1.562 0 001.97 5.425l.009.01 5.21 5.56v5.879a1.562 1.562 0 002.429 1.3l2.5-1.666a1.562 1.562 0 00.695-1.301v-4.212l5.209-5.56.01-.01a1.563 1.563 0 00.273-1.683zm-6.944 6.06c-.272.29-.423.672-.423 1.07v4.168l-1.875 1.25v-5.418c0-.397-.15-.78-.422-1.07L3.846 4.688h12.308L11.36 9.805z"}})])
          )
        }
      }
    